export default Object.freeze({
  Day: 1,
  Month: 2,
});
